// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__DrSaa","inputSearch":"Search_inputSearch__OGPPt"};